const shifts = {
  form: {
    information: {
      directionOptions: {
        from: 'Von der Schule',
        to: 'Zur Schule',
        both: 'Zur Schule & Von der Schule',
      },
    },
  },
};

export default shifts;
